import Cookies from 'js-cookie';

const cookieValidator = (key, value) => {
  const env = window?.origin ?? '';

  if (Cookies.get(key) === undefined || Cookies.get(key) !== value) {
    Cookies.set(key, value, {
      domain: env.replace('https://www', ''),
    });
  }
};

export default cookieValidator;
